<template>
  <a
    :href="item.link"
    :target="item.openInNewTab ? '_blank' : '_self'"
    class="btn flex items-center justify-center"
    :class="[
      btnClass,
      item.roundedCorners ? 'rounded-full' : 'rounded-md',
      item.iconSide === 'right' ? 'flex-row-reverse' : '',
    ]"
    :aria-label="item.label ? null : 'Vind ons op Twitter'"
  >
    <IconTwitterCircle
      class="h-6 w-6"
      :class="item.iconSide === 'right' ? 'ml-2' : 'mr-2'"
      aria-hidden="true"
    />
    <span class="block">{{ item.label }}</span>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import IconTwitterCircle from '../icons/IconTwitterCircle.vue'

const props = defineProps({
  item: {
    type: Object,
    default: () => {},
  },
})

const btnClass = computed(() => {
  return `btn-style-${props.item.style}-twitter`
})
</script>
